import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { NavigationHelper } from 'src/app/core/services/core/navigation-helper.service';
import { fromEntriesArr } from 'src/app/core/utils/utils';

@Component({
  selector: 'app-request-result',
  templateUrl: './request-result.component.html',
  styleUrls: ['./request-result.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RequestResultComponent implements OnInit {
  @Input() titleFirst: boolean;
  @Input() smallTitle: boolean;
  @Input() success;
  @Input() imageOk;
  @Input() imageKo;
  @Input() whiteBoxMode: boolean;
  @Input() i18;
  @Input() descriptionInterpolation = {};
  @Input() onOk = '';
  @Input() onBack = '';
  @Input() hideBtns: boolean;
  @Input() onlyOkButton = false;
  @Input() showOkButton = true;
  @Input() linkI18 = '';
  @Input() subdescriptionEnabled = false;

  @Output() ok = new EventEmitter();
  @Output() back = new EventEmitter();
  @Output() link = new EventEmitter();

  translation = {};
  resultDescriptionKoInnerHtml: SafeHtml;

  constructor(
    public nav: NavigationHelper,
    public trans: TranslateService,
    private domSanitizer: DomSanitizer,
  ) {}

  ngOnInit() {
    forkJoin([
      this.trans.get(
        [
          'DEFAULT.RESULT.TITLE_OK',
          'DEFAULT.RESULT.TITLE_KO',
          'DEFAULT.RESULT.DESCRIPTION_OK',
          'DEFAULT.RESULT.DESCRIPTION_KO',
          'DEFAULT.RESULT.BUTTON_CONFIRM_OK',
          'DEFAULT.RESULT.BUTTON_CONFIRM_KO',
          'DEFAULT.RESULT.BUTTON_BACK'
        ],
        this.descriptionInterpolation
      ),
      this.trans.get(
        [
          this.i18 + '.RESULT.TITLE_OK',
          this.i18 + '.RESULT.TITLE_KO',
          this.i18 + '.RESULT.DESCRIPTION_OK',
          this.i18 + '.RESULT.DESCRIPTION_KO',
          this.i18 + '.RESULT.SUB_DESCRIPTION_OK',
          this.i18 + '.RESULT.SUB_DESCRIPTION_KO',
          this.i18 + '.RESULT.BUTTON_CONFIRM_OK',
          this.i18 + '.RESULT.BUTTON_CONFIRM_KO',
          this.i18 + '.RESULT.BUTTON_BACK'
        ],
        this.descriptionInterpolation
      )
    ])
      .pipe(
        map(([i18default, i18custom]) => {
          return Object.entries(i18custom)
            .map(([key, value]) =>
              key === value
                ? [
                    key,
                    i18default[
                      'DEFAULT.RESULT.' +
                        key.substring(key.lastIndexOf('.') + 1)
                    ]
                  ]
                : [key, value]
            )
            .reduce(fromEntriesArr, {});
        })
      )
      .subscribe(translation => (this.translation = translation));
    this.resultDescriptionKoInnerHtml =
      this.domSanitizer.bypassSecurityTrustHtml(
        this.translation[this.i18 + '.RESULT.DESCRIPTION_KO']
      );
  }

  onOkBtn() {
    this.ok.emit('ok');
    if (this.onOk) {
      this.nav.newRoot(this.onOk);
    }
  }

  onBackBtn() {
    this.back.emit('back');
    if (this.onBack) {
      this.nav.newRoot(this.onBack);
    }
  }

  onLink() {
    this.link.emit('link');
  }
}
